import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import Image1 from "../assets/images/collaboration_no_bg_v2.png";
import { FaArrowRight } from "react-icons/fa";

const LPHeroSection = () => {
  const navigate = useNavigate();

  // Split the heading text into individual words for animation
  const firstLine = "Beyond Campus Walls.";
  const secondLine = "Welcome To Scholarty.";

  // Animation variants
  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.08,
        delayChildren: 0.3,
      },
    },
  };

  const item = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: { type: "spring", stiffness: 100 },
    },
  };

  return (
    <div className="bg-white text-black pb-8 pt-2 md:pt-4 font-inter">
      <div className="container mx-auto relative">
        <div className="flex flex-col md:flex-row items-center">
          {/* Left Column: Text Content */}
          <div className="w-full w-[60%] md:w-[63%] text-center md:text-left mb-4 md:mb-0 relative z-10 p-6 md:p-0 md:mr-10">
            <motion.h1
              className="text-4xl md:text-5xl xl:text-7xl font-bold mb-3 lg:whitespace-nowrap"
              initial="hidden"
              animate="visible"
              variants={container}
            >
              <div className="overflow-hidden py-2">
                {firstLine.split(" ").map((word, index) => (
                  <React.Fragment key={index}>
                    <motion.span className="inline-block mr-3.5" variants={item}>
                      {word}{" "}
                    </motion.span>
                    {word === "Beyond" && <br className="md:hidden" />}
                  </React.Fragment>
                ))}
              </div>
              <div className="overflow-hidden py-1">
                {secondLine.split(" ").map((word, index) => (
                  <React.Fragment key={index}>
                    <motion.span className="inline-block mr-3.5" variants={item}>
                      {word}{" "}
                    </motion.span>
                    {word === "Welcome" && <br className="md:hidden" />}
                  </React.Fragment>
                ))}
              </div>
            </motion.h1>
            <motion.p
              className="text-base md:text-lg xl:text-xl 2xl:text-2xl mb-6 md:mb-8 text-[#5C5C5C]"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.2, duration: 0.5 }}
            >
              A student network designed to help you reach more people, grow
              your club, and unlock new opportunities beyond the usual circles.
            </motion.p>
            <motion.a
              onClick={() => navigate("/join-us")}
              className="inline-block bg-[#5379F6] hover:bg-[#4A6ACB] text-white px-8 py-4 rounded-lg shadow-md transition duration-300 text-lg inline-flex items-center justify-center"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 1.5, duration: 0.5 }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Join the Beta Test Waitlist <FaArrowRight className="ml-3" />
            </motion.a>
          </div>

          {/* Right Column: Image */}
          <motion.div
            className="w-[90%] md:w-[36%] lg:w-[50%] flex items-center justify-center"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.8, duration: 0.8 }}
          >
            <div className="w-full rounded-lg overflow-hidden bg-white p-2 md:p-4">
              <img
                src={Image1}
                alt="Scholarty collaboration illustration"
                className="w-full h-auto object-contain max-h-[380px] md:max-h-[460px] lg:max-h-[500px] xl:max-h-[540px]"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default LPHeroSection;
